export function checkboxCustom() {

    let checkboxBlock = document.querySelectorAll('[am-checkbox]');
    checkboxBlock.forEach(function(item) {

        if (item.classList.contains('is-initialized')) {
            return false;
        }
        item.classList.add('is-initialized');

        item.addEventListener('click', function(e) {
            item.classList.remove('error');
            let checkbox = item.querySelector('input');
            if (checkbox.checked) {
                item.classList.add('is-checked');
            } else {
                item.classList.remove('is-checked');
            }
        });
    });

}
